// extracted by mini-css-extract-plugin
module.exports = {"loadMore":"InfiniteStories_loadMore__dIX_B"};